"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonControlWrapper$ = exports.PersonControlWrapper$outboundSchema = exports.PersonControlWrapper$inboundSchema = void 0;
exports.personControlWrapperToJSON = personControlWrapperToJSON;
exports.personControlWrapperFromJSON = personControlWrapperFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const personsignificantcontrol_js_1 = require("./personsignificantcontrol.js");
/** @internal */
exports.PersonControlWrapper$inboundSchema = z.object({
    attributes: z.array(z.array(personsignificantcontrol_js_1.PersonSignificantControl$inboundSchema)),
    id: z.string(),
    type: z.literal("company").default("company").optional(),
});
/** @internal */
exports.PersonControlWrapper$outboundSchema = z.object({
    attributes: z.array(z.array(personsignificantcontrol_js_1.PersonSignificantControl$outboundSchema)),
    id: z.string(),
    type: z.literal("company").default("company"),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PersonControlWrapper$;
(function (PersonControlWrapper$) {
    /** @deprecated use `PersonControlWrapper$inboundSchema` instead. */
    PersonControlWrapper$.inboundSchema = exports.PersonControlWrapper$inboundSchema;
    /** @deprecated use `PersonControlWrapper$outboundSchema` instead. */
    PersonControlWrapper$.outboundSchema = exports.PersonControlWrapper$outboundSchema;
})(PersonControlWrapper$ || (exports.PersonControlWrapper$ = PersonControlWrapper$ = {}));
function personControlWrapperToJSON(personControlWrapper) {
    return JSON.stringify(exports.PersonControlWrapper$outboundSchema.parse(personControlWrapper));
}
function personControlWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PersonControlWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PersonControlWrapper' from JSON`);
}
//# sourceMappingURL=personcontrolwrapper.js.map